import { LATE_GOAL_CONFIG } from '../config/late';
import { TransformedEvents } from '../models/MatchMongo';

export const isLateGoalBaseOnTime = (elapsed: number) => {
  if (elapsed >= LATE_GOAL_CONFIG.htStart && elapsed <= LATE_GOAL_CONFIG.htStop) {
    return true;
  }
  if (elapsed >= LATE_GOAL_CONFIG.ftStart && elapsed <= LATE_GOAL_CONFIG.ftStop) {
    return true;
  }
  return false;
};

export const countLateGoals = (event: TransformedEvents) => {
  return isLateGoalBaseOnTime(event.time.elapsed);
};
